<template>
  <div>
    <page-container>
      <section class="pdf-shopSale-detail">
        <div class="pdf-content-container">
          <div class="pdf-ticketSale-detail-table">
            <el-row :gutter="20">
              <el-col :span="16">
                <h2 class="CL-title">{{$locale("pdf.ticketSale.title")}}</h2>
                <p class="subTitle">{{$locale("pdf.ticketSale.subTitle")}}</p>
                <el-table
                  border
                  size="small"
                  :data="tableData"
                  header-row-class-name="tableHeader"
                  cell-class-name="tableTd"
                  :header-row-style="headerRowStyle"
                  :span-method="spanMethod"
                >
                  <el-table-column
                    :label="$locale('pdf.shopSale.tableName')"
                    label-class-name="columnTitle"
                    align="center"
                  >
                    <el-table-column
                      v-for="head in header"
                      :key="head.prop"
                      :label="head.label"
                      :prop="head.prop"
                      :align="head.align"
                      :min-width="head.width"
                      header-align="center"
                      :resizable="false"
                      :formatter="priceFormat"
                    >
                      <template v-if="head.subItem">
                        <el-table-column
                          v-for="item in head.subItem"
                          :key="item.prop"
                          :prop="item.prop"
                          :align="item.align"
                          :resizable="false"
                          :min-width="item.width"
                        ></el-table-column>
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8" class="table2">
                <p class="CL-title2">{{$locale("pdf.ticketSale.liquidationReport.title")}}</p>
                <p class="subTitle">{{$locale("pdf.ticketSale.liquidationReport.subTitle")}}</p>
                <el-table
                  border
                  size="small"
                  :data="tableData2"
                  :header-row-style="headerReportRowStyle"
                  :span-method="spanMethodReport"
                >
                  <el-table-column>
                    <el-table-column
                      prop="number"
                      min-width="20"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="name"
                      align="center"
                    ></el-table-column>
                  </el-table-column>
                  <el-table-column
                    label=""
                    prop="amount"
                    align="right"
                    :formatter="priceFormatForReport"
                  ></el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>
      </section>
    </page-container>
  </div>
</template>
<script>
import PageContainer from "@/components/PdfTicketSaleDetail/PageContainer";
import { getPdfData, getReportPdfData } from "@/assets/js/pdfTicketSaleDetail";
import { toThousands } from "@/utils/common.js";
export default {
  name: "ShopSale-Detail-Pdf",
  data() {
    return {
      header: [
        {
          label: this.$locale("pdf.ticketSale.project"),
          align: "center",
          subItem: [
            {
              prop: "type",
              align: "center",
              width: 20
            },
            {
              prop: "name",
              align: "center",
              width: 90
            },
          ]
        },
        {
          label: this.$locale("pdf.ticketSale.item"),
          prop: "number",
          align: "center",
          width: 40,
        },
        {
          label: this.$locale("pdf.ticketSale.summary"),
          prop: "summary",
          align: "center",
          width: 120,
        },
        {
          label: this.$locale("pdf.ticketSale.taxOutAmount"),
          prop: "actualAmount",
          align: "right",
          width: 120,
        },
        {
          label: this.$locale("pdf.ticketSale.saleTax"),
          prop: "tax",
          align: "right",
        },
        {
          label: this.$locale("pdf.ticketSale.taxAmount"),
          prop: "amount",
          align: "right",
          width: 100,
        }
      ],
      printMode: false,
    };
  },
  methods: {
    setPrintMode(status) {
      this.printMode = status;
    },
    headerRowStyle({ rowIndex }) {
      if (rowIndex === 2) {
        return "display: none";
      }
    },
    headerReportRowStyle({ rowIndex }) {
      if (rowIndex < 2) {
        return "display: none";
      }
    },
    pushDataFromPdfData(val) {
      if(val) {
        return getPdfData(val, "pay");
      }
      return [];
    },
    pushReportDataFromPdfData(val) {
      if(val) {
        return getReportPdfData(val, "pay");
      }
      return [];
    },
    spanMethod({ rowIndex, columnIndex }) {
      if(columnIndex === 0 && (rowIndex < 2 || rowIndex > 10)) {
        return {
          rowspan: 1,
          colspan: 2
        };
      } else if(columnIndex === 1 && (rowIndex < 2 || rowIndex > 10)) {
        return {
          rowspan: 0,
          colspan: 0
        };
      }
      if(columnIndex === 0) {
        if(rowIndex === 2) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else if(rowIndex > 2 && rowIndex < 8) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
        if(rowIndex === 8) {
          return {
            rowspan: 3,
            colspan: 1,
          };
        } else if(rowIndex > 8 && rowIndex < 11) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    spanMethodReport({ rowIndex, columnIndex }) {
      if (rowIndex < 3) {
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
    priceFormat(row, column, cellValue, index) {
      if (index > 1) {
        switch(column.property) {
        case "actualAmount":
          return toThousands(cellValue);
        case "tax":
          return toThousands(cellValue);
        case "amount":
          return toThousands(cellValue);
        default:
          return cellValue;
        }
      } else {
        return cellValue;
      }
    },
    priceFormatForReport(row, column, cellValue, index) {
      if (index > 2) {
        switch(column.property) {
        case "amount":
          return toThousands(cellValue);
        default:
          return cellValue;
        }
      } else {
        return cellValue;
      }
    }
  },
  computed: {
    tableData() {
      if (!this.$_.isEmpty(this.pdfData)) {
        return this.pushDataFromPdfData(this.pdfData).filter(item => item !== undefined);
      }
      return [];
    },
    tableData2() {
      if (!this.$_.isEmpty(this.pdfData)) {
        return this.pushReportDataFromPdfData(this.pdfData);
      }
      return [];
    },
  },
  props: {
    pdfData: {
      type: Object,
      default: () => ({}),
    }
  },
  components: {
    PageContainer
  }
};
</script>
<style lang="less">
@import url("../PdfTicketSaleDetail/style.less");
</style>